"use client";

import { getResponseError } from "@/lib/utils";
import { getEnv } from "@/env";
import newrelic from "@/lib/monitoring/newrelic";

const refreshUserJwt = async () => {
  const startTime = Date.now();

  try {
    const response = await fetch(
      `${getEnv("NEXT_PUBLIC_LMS_BASE_URL")}/login_refresh`,
      {
        method: "POST",
        credentials: "include",
      },
    );

    const responseTime = Date.now() - startTime;

    if (!response.ok) {
      const error = await getResponseError(response);

      // Don't report 401 errors to NewRelic as they are expected
      if (response.status !== 401) {
        newrelic.noticeError(error, {
          submodule: "auth",
          endpoint: "login_refresh",
          status: response.status,
          responseTime: responseTime,
          timestamp: new Date().toISOString(),
        });
      }

      return false;
    }

    newrelic.addPageAction("refreshUserJwt.success", {
      responseTime: responseTime,
    });

    return true;
  } catch (error) {
    const responseTime = Date.now() - startTime;

    // Network error logging
    newrelic.noticeError(error as Error, {
      submodule: "auth",
      endpoint: "login_refresh",
      context: "networkError",
      responseTime: responseTime,
      timestamp: new Date().toISOString(),
    });

    return false;
  }
};

export default refreshUserJwt;
